import type React from 'react'
import type { SVGProps } from 'react'

type Props = {
  className?: string
  size?: number
} & SVGProps<SVGSVGElement>

const IconWorld: React.FC<Props> = ({ className, size = 16, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M8 1.375C12.1309 1.375 15.5 4.74414 15.5 8.875C15.5 13.0352 12.1309 16.375 8 16.375C3.83984 16.375 0.5 13.0352 0.5 8.875C0.5 4.74414 3.83984 1.375 8 1.375ZM8 14.9688C8.20508 14.9688 8.76172 14.7637 9.37695 13.5625C9.64062 13.0352 9.8457 12.4199 10.0215 11.6875H5.94922C6.125 12.4199 6.33008 13.0352 6.59375 13.5625C7.20898 14.7637 7.76562 14.9688 8 14.9688ZM5.71484 10.2812H10.2559C10.3145 9.8418 10.3438 9.37305 10.3438 8.875C10.3438 8.40625 10.3145 7.9375 10.2559 7.46875H5.71484C5.65625 7.9375 5.65625 8.40625 5.65625 8.875C5.65625 9.37305 5.65625 9.8418 5.71484 10.2812ZM10.0215 6.0625C9.8457 5.35938 9.64062 4.74414 9.37695 4.2168C8.76172 3.01562 8.20508 2.78125 8 2.78125C7.76562 2.78125 7.20898 3.01562 6.59375 4.2168C6.33008 4.74414 6.125 5.35938 5.94922 6.0625H10.0215ZM11.6621 7.46875C11.7207 7.9375 11.75 8.40625 11.75 8.875C11.75 9.37305 11.7207 9.8418 11.6621 10.2812H13.918C14.0352 9.8418 14.0938 9.37305 14.0938 8.875C14.0938 8.40625 14.0352 7.9375 13.918 7.46875H11.6621ZM10.5195 3.33789C10.9297 4.09961 11.252 5.03711 11.457 6.0625H13.3906C12.7754 4.86133 11.75 3.89453 10.5195 3.33789ZM5.45117 3.33789C4.2207 3.89453 3.19531 4.86133 2.58008 6.0625H4.51367C4.71875 5.03711 5.04102 4.09961 5.45117 3.33789ZM1.90625 8.875C1.90625 9.37305 1.93555 9.8418 2.05273 10.2812H4.30859C4.25 9.8418 4.25 9.37305 4.25 8.875C4.25 8.40625 4.25 7.9375 4.30859 7.46875H2.05273C1.93555 7.9375 1.90625 8.40625 1.90625 8.875ZM13.3906 11.6875H11.457C11.252 12.7422 10.9297 13.6797 10.5195 14.4414C11.75 13.8848 12.7754 12.918 13.3906 11.6875ZM4.51367 11.6875H2.58008C3.19531 12.918 4.2207 13.8848 5.45117 14.4414C5.04102 13.6797 4.71875 12.7422 4.51367 11.6875Z"
      fill="currentColor"
    />
  </svg>
)

export default IconWorld
